import { createAsteroid } from "./asteroid"

import { checkElementsVisibility } from "../helpers/checkElementsVisibility"

export class AsteroidMovement {
  constructor(
    rocket,
    boardContainer,
    handleLose,
    verticalMovingUpdater,
    moveToAsteroidNow,
    getIsMovingDirectionRight,
    moveNow,

  ) {
    this.rocket = rocket
    this.boardContainer = boardContainer
    this.asteroids = []
    this.randX = null
    this.interval = null
    this.wasThereBoom = false
    this.handleLose = handleLose
    this.verticalMovingUpdater = verticalMovingUpdater
    this.moveToAsteroidNow = moveToAsteroidNow
    this.getIsMovingDirectionRight = getIsMovingDirectionRight
    this.gameAbortHandler = null
    this.moveNow = moveNow
    this.ticker = null

  }
  clearAsteroidInterval = () => clearInterval(this.interval)
  clearAsteroids = () => (this.asteroids.length = 0)
  setTickerAsteroidMovement = (ticker) => (this.ticker = ticker)
  setGameAbortHandler = (handler) => (this.gameAbortHandler = handler)

  goAsteroids = () => {
    this.goAsteroid(false)
    this.interval = setInterval(this.goAsteroid, 1500)
  }
  goAsteroid = (isReal) => {
    if (document.visibilityState === "visible") {
      const isRocketOnscreen = this.boardContainer.children.some(
        (item) => item.name === "rocket",
      )
      if (isRocketOnscreen) {
        this.testIngAsteroids++
        let [asteroid, randX2] = createAsteroid(isReal)
        this.randX = randX2
        this.asteroids.push(asteroid)
        this.boardContainer.addChild(asteroid)
        checkElementsVisibility(this.boardContainer, this.gameAbortHandler)
        this.ticker.remove(this.goAsteroidTicker)
        this.ticker.add(this.goAsteroidTicker)
      }
    }
  }
  setWasThereBoom = () => (this.wasThereBoom = false)
  goAsteroidTicker = (delta) => {
    this.asteroids.map((ast) => {
      ast.asteroidDistance += 2.5 * delta
      ast.y = ast.asteroidDistance
      ast.rotation += ast.randRotation
      if (ast.isReal) {
        if (ast.asteroidDistance > 145 && !ast.moved) {
          ast.moved = true
          this.moveToAsteroidNow()
        }
        if (ast.asteroidDistance > 145) {
          if (this.rocket.x < ast.x + 10 && this.rocket.x > ast.x - 10) {
            if (!this.wasThereBoom) {
              this.wasThereBoom = true
              this.ticker.remove(this.verticalMovingUpdater)
              this.handleLose()

              this.asteroids = []
              const astsInContainer = this.boardContainer.children.filter(
                (item) => item.name === "ast",
              )
              astsInContainer.map((ast) => this.boardContainer.removeChild(ast))
            }
          }
        }
        if (ast.asteroidDistance > 450) {
          this.boardContainer.removeChild(ast)
          this.asteroids.shift()
        }
      } else {
        if (ast.asteroidDistance > 64 && !ast.moved) {
          ast.moved = true
          this.moveNow(this.randX)
        }
        if (ast.asteroidDistance > 450) {
          this.boardContainer.removeChild(ast)
          this.asteroids.shift()
        }
      }

      return ast
    })

    if (this.asteroids.length === 0) {
      this.ticker.remove(this.goAsteroidTicker)
    }
  }

  goRealAsteroid = () => {
    // clearInterval(interval)
    this.clearAsteroidInterval()
    setTimeout(() => {
      this.goAsteroid(true)
    }, 1000)
  }
}
